import { render, staticRenderFns } from "./ListaReembolsosPorPaciente.vue?vue&type=template&id=79d472e0&scoped=true"
import script from "./ListaReembolsosPorPaciente.vue?vue&type=script&lang=js"
export * from "./ListaReembolsosPorPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d472e0",
  null
  
)

export default component.exports